var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.84 27.87",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d82945;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.19 13.12 11.19 15.44 16.38 15.44 16.38 13.12 13.79 10.8 11.19 13.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.29,18.32a11.62,11.62,0,0,1-1.75,2.86V10.38L14,2.74l-.07-.07a11.1,11.1,0,0,1,4.36.89,11.29,11.29,0,0,1,6,14.76M19.54,23.7a11.26,11.26,0,0,1-3,1.19V18.37H11.29v6.51a12.75,12.75,0,0,1-1.75-.56,12.42,12.42,0,0,1-1.26-.64V20.92h0v-9.2l5.63-5,5.61,5v9.2h0ZM5.28,10.38V21.15c-.24-.3-.48-.6-.69-.92A11.26,11.26,0,0,1,13.91,2.67l-.08.07ZM26.74,8.51a13.94,13.94,0,1,0,1.1,5.43,13.93,13.93,0,0,0-1.1-5.43"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AUD.8a5619b66e3c4acdf3581877b2e4ba31.svg";